// extracted by mini-css-extract-plugin
export var openButton = "ProductWidget-module--openButton--35imZ";
export var component = "ProductWidget-module--component--3TX_8";
export var collapseBox = "ProductWidget-module--collapseBox--2DcyD";
export var chevronOpen = "ProductWidget-module--chevron-open--1ba7N";
export var chevronClose = "ProductWidget-module--chevron-close--BOPDy";
export var spinAround = "ProductWidget-module--spinAround--GjUO8";